import $ from 'jquery';
import Flickity from 'flickity';
import EventHandler from '@pixelunion/events';
import * as breakpoint from '@pixelunion/breakpoint';

export default class StaticSlideshow {
  constructor({el, data}) {
    this.el = el;
    this.mainHeader = document.querySelector('[data-main-header]');
    this.headerLogo = this.mainHeader.querySelector('[data-header-logo]');
    this.slideContainer = this.el.querySelector('[data-slideshow-container]');

    this.full_bleed = data.full_bleed;
    this.autoplay = data.autoplay;
    this.autoplay_frequency = data.autoplay_frequency;
    this.thumbnail_pagination = data.thumbnail_pagination;

    // These 2 blocks don't meet our current code standards and structure
    // but are included for compatibility with the existing header code
    if (this.headerLogo) {
      $(document.body).trigger('swapLogo');
    }

    if (this.full_bleed) {
      this.mainHeader.classList.add('full-bleed-slideshow');
    }

    const slideSelector = '[data-slide]'
    this.slideCount = this.el.querySelectorAll(slideSelector).length;
    this.slideshow = null;

    this.events = new EventHandler();

    const flickityOptions = {
      adaptiveHeight: true,
      autoPlay: this.autoplay ? this.autoplay_frequency : 0,
      cellAlign: 'center',
      cellSelector: slideSelector,
      freeScroll: false,
      pageDots: !this.thumbnail_pagination,
      prevNextButtons: true,
      wrapAround: true,
    };

    if (this.slideCount > 1) {
      this.slideshow = new Flickity(this.slideContainer, flickityOptions);

      this.prevNextButtons = this.el.querySelectorAll('.flickity-prev-next-button');
      this._setPrevNextButtonPosition();

      this.events.register(this.slideContainer, 'rimg:load', () => { this.slideshow.resize() });
      this.events.register(window, 'resize', () => this._setPrevNextButtonPosition());

      this.slideshow.on('select', () => this._setPrevNextButtonPosition());

      if (this.thumbnail_pagination) {
        this.thumbnailContainer = this.el.querySelector('[data-slideshow-pagination]');

        this.events.register(this.thumbnailContainer, 'click', ({ target }) => {
          this.slideshow.select(target.dataset.paginationSlide);
        });

        this.slideshow.on('select', index => this._setSelectedThumbnail(index));
      }
    }
  }

  _setPrevNextButtonPosition() {
    if (breakpoint.min('M')) {
      this.prevNextButtons.forEach(button => button.style.height = '');
      return;
    }

    const { height } = this.el.querySelector('[data-slide].is-selected .slide-image')
      .getBoundingClientRect();

    this.prevNextButtons.forEach(button => button.style.height = `${height}px`);
  }

  _setSelectedThumbnail(index) {
    const thumbnail = this.thumbnailContainer.querySelector(`[data-pagination-slide="${index}"]`)
    thumbnail.classList.add('is-selected');

    if (this.selectedThumbnail) {
      this.selectedThumbnail.classList.remove('is-selected');
    }

    this.selectedThumbnail = thumbnail;
  }

  onSectionBlockSelect(block) {
    if (!this.slideshow) return;
    this.slideshow.pausePlayer();
    this.slideshow.select(block.el.dataset.slide, false, true);
  }

  onSectionBlockDeselect() {
    if (!this.slideshow) return;
    this.slideshow.unpausePlayer();
  }

  onSectionUnload() {
    this.mainHeader.classList.remove('full-bleed-slideshow');
    $(document.body).trigger('swapLogo');
    this.events.unregisterAll();
    this.slideshow.destroy();
  }
}
